import PropTypes from "prop-types";
import React from "react";
import {
  useTheme,
  ThemeProvider,
  StyledEngineProvider
} from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import learningCenterDarkTheme from "../../theme/learningCenterDarkTheme";
import ellipseBgImgLeft from "../../assets/svgs/leftEllipseBg.svg";
import ellipseBgImgRight from "../../assets/svgs/rightEllipseBg.svg";

const useStyles = makeStyles(theme => ({
  root: {
    height: "100%"
  }
}));

function getEllipseBackground(ellipseBackground) {
  if (ellipseBackground === "left") {
    return `url(${ellipseBgImgLeft})`;
  } else if (ellipseBackground === "right") {
    return `url(${ellipseBgImgRight})`;
  } else {
    return "none";
  }
}

function getGradient(direction) {
  // TODO: get gradient colors from theme
  if (direction === "ltr") {
    return "linear-gradient(90deg, #2B3990 0%, #262262 100%)";
  } else if (direction === "rtl") {
    return "linear-gradient(90deg, #262262 0%, #2B3990 100%)";
  }
}

/**
 * Creates a banner that contains the children passed in. Automatically applies the filled theme to the
 * children
 */
const Banner = ({ children, gradientDirection, ellipseBackground }) => {
  const theme = useTheme();
  const classes = useStyles();
  const backgroundStyle =
    gradientDirection !== "none"
      ? {
          background: getGradient(gradientDirection)
        }
      : { backgroundColor: theme.palette.secondary.main };

  const backgroundImageStyle = {
    backgroundImage: getEllipseBackground(ellipseBackground),
    backgroundSize: "cover",
    backgroundPositionX: "center"
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={learningCenterDarkTheme(theme)}>
        <div style={backgroundStyle} className={classes.root}>
          <div style={backgroundImageStyle} className={classes.root}>
            {children}
          </div>
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default Banner;

Banner.propTypes = {
  /**
   * The content of the banner
   */
  children: PropTypes.node,
  /**
   * ltr starts on the lighter side and ends on the darker side,
   * rtl starts on the darker side and ends on the lighter side,
   * none applies no gradient
   */
  gradientDirection: PropTypes.oneOf(["rtl", "ltr", "none"]),
  /**
   * applies an ellipse background to the banner
   */
  ellipseBackground: PropTypes.oneOf(["none", "left", "right"])
};

Banner.defaultProps = {
  ellipseBackground: "none",
  gradientDirection: "none"
};
